















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mask } from 'vue-the-mask';

import Assets from '@/constants/assets';
import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';

export { IconEnum };

@Component({
  components: {
    Icon,
  },
})
export default class FieldSet extends Vue {
  @Prop({ default: '' }) private fieldValue!: string;
  @Prop() private fieldLabel!: string;
  @Prop({ default: '' }) private fieldIcon!: string;

  get hasIcon() {
    return this.fieldIcon.length > 0;
  }

  private iconClick() {
    this.$emit('icon-click');
  }
}
